import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import "./PopupContact.css";
import { toast } from "react-toastify";

const PopupContact = () => {
  const [formData, setFormData] = useState({ name: "", phoneNumber: "" });
  const [uploading, setUploading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  // Show popup after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  // Close popup function
  const handleClose = () => {
    setShowPopup(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    try {
      await addDoc(collection(db, "popup_contacts"), formData);
      toast.success("Message Submitted Successfully!");
      setFormData({ name: "", phoneNumber: "" });
      handleClose(); // Close popup after submitting
    } catch (error) {
      console.error("Error submitting contact: ", error);
      toast.error("Something went wrong. Please try again.");
    }
    setUploading(false);
  };

  if (!showPopup) return null; // Don't render if popup is closed

  return ReactDOM.createPortal(
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="popup-close" onClick={handleClose}>X</button>
        <h2 className="heading-contact">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <label className="label">Name:</label>
          <input type="text" name="name" placeholder="Enter your Full name" value={formData.name} onChange={handleChange} required />
          
          <label className="label">Mobile Number:</label>
          <input type="tel" name="phoneNumber" placeholder="Enter your Mobile number" value={formData.phoneNumber} onChange={handleChange} required />
          
          <button type="submit" className="submit-button" disabled={uploading}>
            {uploading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>,
    document.getElementById("popup-root") // Ensure this div exists in index.html
  );
};

export default PopupContact;
